export function openPhoneDialer(phoneNumber: string) {
  const telNumber = encodeURIComponent(phoneNumber);
  const url = `tel:${telNumber}`;
  window.open(url, "_blank");
}

